import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const Content = () => {
    return (
        <section className="content-section py-5">
            <div className="container">
                {/* Título */}
                <div className="title-container" data-aos="fade-up">
                    <h2 className="title">Contenido</h2>
                    <div className="title-underline"></div>
                </div>

                <div className="section-description" data-aos="fade-up">
                    <p>
                        <span className='description-highlight'>En BeHealth creemos que el contenido es el corazón de toda estrategia exitosa.</span>
                        Por eso, ofrecemos un amplio ecosistema de herramientas diseñadas para adaptarse a las necesidades
                        de tu marca, desde formatos educativos y dinámicos hasta soluciones promocionales que maximizan
                        el alcance y el impacto en tu audiencia.
                    </p>
                </div>

                <div className='row justify-content-center'>


                    <div className='col-md-4 text-center mt-5' data-aos="fade-up" data-aos-delay="0">
                        <div className=' position-relative content-number z-4 shadow-lg'>
                            <p className='position-absolute top-0 translate-middle p-3'>01</p>
                        </div>
                        <div className='position-relative content-p-1 z-3 shadow-lg'>
                            <p>
                                Podcast<br />
                                Cápsulas educativas<br />
                                BeHealth TV
                            </p>
                        </div>
                        <div className='position-relative content-p-2 z-2 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Educación y Valor
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#2daa66" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                        <div className='position-relative content-img z-1 shadow-lg'>
                            <img src="assets/contenido-1.png" alt="" className='img-fluid w-100' />
                        </div>
                        <div className='position-relative content-p-3 z-0 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Información y aprendizaje
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#1a7742" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>


                    <div className='col-md-4 text-center mt-5' data-aos="fade-up" data-aos-delay="200">
                        <div className=' position-relative content-number z-4 shadow-lg'>
                            <p className='position-absolute top-0 translate-middle p-3'>02</p>
                        </div>
                        <div className='position-relative content-p-1 z-3 shadow-lg'>
                            <p>
                                Micrositios<br />
                                Lives & Webinars<br />
                                Reels

                            </p>
                        </div>
                        <div className='position-relative content-p-2 z-2 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Interacción y Engagement
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#b1ce64" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                        <div className='position-relative content-img z-1 shadow-lg'>
                            <img src="assets/contenido-2.png" alt="" className='img-fluid w-100' />
                        </div>
                        <div className='position-relative content-p-3 z-0 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Conexión activa
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#26c757" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>


                    <div className='col-md-4 text-center mt-5' data-aos="fade-up" data-aos-delay="400">
                        <div className=' position-relative content-number z-4 shadow-lg'>
                            <p className='position-absolute top-0 translate-middle p-3'>03</p>
                        </div>
                        <div className='position-relative content-p-1 z-3 shadow-lg'>
                            <p>
                                Contextuales<br />
                                Emeil Marketing<br />
                                Contenido editorial

                            </p>
                        </div>
                        <div className='position-relative content-p-2 z-2 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Promoción y alcance
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#17ada2" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                        <div className='position-relative content-img z-1 shadow-lg'>
                            <img src="assets/contenido-3.png" alt="" className='img-fluid w-100' />
                        </div>
                        <div className='position-relative content-p-3 z-0 shadow-lg'>
                            <p className='pt-5 pb-2'>
                                Visibilidad estratégica
                            </p>

                            <div className='position-absolute top-100 start-50 translate-middle mt-1'>
                                <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#056059" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </section>
    );
};

export default Content;